if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        // if (prepend) {
        //   activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

        //   if (this.elements.thumbnails) {
        //     const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        //     activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
        //   }

        //   if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        // }

        if (prepend) {
          // DOM move hataaya — sirf active class lagao
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        // window.setTimeout(() => {
        //   if (!this.mql.matches || this.elements.thumbnails) {
        //     activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        //   }

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
          }

          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}







// document.addEventListener('DOMContentLoaded', () => {
//   const gallery = document.querySelector('media-gallery');
//   if (!gallery) return;

//   const prev = gallery.querySelector('.custom-prev');
//   const next = gallery.querySelector('.custom-next');

//   // const items = gallery.querySelectorAll('.product__media-item');
//   const getVisibleItems = () => [...gallery.querySelectorAll('.product__media-item')].filter(el => el.style.display !== 'none');

//   // let currentIndex = 0;
//   let currentIndex = 0;
//   window._galleryCurrentIndex = 0;

//   const isMobile = () => window.innerWidth < 750;

//   // ✅ Desktop: set active image
//   const setActive = (index) => {
//     items.forEach((el) => el.classList.remove('is-active'));
//     items[index].classList.add('is-active');
//     currentIndex = index;
//     window._galleryCurrentIndex = index; // yeh add karo
//   };

//   // ✅ Mobile: get scroll container
//   const getScrollContainer = () => {
//     return gallery.querySelector('ul') || gallery.querySelector('.media-gallery');
//   };

//   // ✅ PREV FUNCTION
//   const handlePrev = (e) => {
//     e.preventDefault();
//     e.stopPropagation();

//     if (isMobile()) {
//       const scroller = getScrollContainer();
//       if (!scroller) return;

//       scroller.scrollBy({
//         left: -scroller.clientWidth,
//         behavior: 'smooth'
//       });
//     } else {

//       // let newIndex = currentIndex - 1;
//       // if (newIndex < 0) newIndex = items.length - 1;
//       // setActive(newIndex);

//       // const visibleItems = getVisibleItems();
//       // const visibleIndex = visibleItems.indexOf(visibleItems.find(el => el.classList.contains('is-active')));
//       // let newIndex = visibleIndex - 1;
//       // if (newIndex < 0) newIndex = visibleItems.length - 1;
//       // visibleItems.forEach(el => el.classList.remove('is-active'));
//       // visibleItems[newIndex].classList.add('is-active');
//       // currentIndex = [...gallery.querySelectorAll('.product__media-item')].indexOf(visibleItems[newIndex]);

//       // handlePrev - desktop branch
//       const visibleItems = getVisibleItems();
//       const activeEl = visibleItems.find(el => el.classList.contains('is-active'));
//       const visibleIndex = visibleItems.indexOf(activeEl);
//       let newIndex = visibleIndex - 1;
//       if (newIndex < 0) newIndex = visibleItems.length - 1;

//       // ✅ mediaId nikalo aur setActiveMedia call karo
//       const mediaId = visibleItems[newIndex].dataset.mediaId;
//       if (mediaId) {
//         gallery.setActiveMedia(mediaId, false); // yeh thumbnail bhi sync karega
//       } else {
//         // fallback
//         visibleItems.forEach(el => el.classList.remove('is-active'));
//         visibleItems[newIndex].classList.add('is-active');
//       }
//       currentIndex = [...gallery.querySelectorAll('.product__media-item')].indexOf(visibleItems[newIndex]);
//     }
//   };

//   // ✅ NEXT FUNCTION
//   const handleNext = (e) => {
//     e.preventDefault();
//     e.stopPropagation();

//     if (isMobile()) {
//       const scroller = getScrollContainer();
//       if (!scroller) return;

//       scroller.scrollBy({
//         left: scroller.clientWidth,
//         behavior: 'smooth'
//       });
//     } else {
      
//       // let newIndex = currentIndex + 1;
//       // if (newIndex >= items.length) newIndex = 0;
//       // setActive(newIndex);

//       // const visibleItems = getVisibleItems();
//       // const visibleIndex = visibleItems.indexOf(visibleItems.find(el => el.classList.contains('is-active')));
//       // let newIndex = visibleIndex + 1;
//       // if (newIndex >= visibleItems.length) newIndex = 0;
//       // visibleItems.forEach(el => el.classList.remove('is-active'));
//       // visibleItems[newIndex].classList.add('is-active');
//       // currentIndex = [...gallery.querySelectorAll('.product__media-item')].indexOf(visibleItems[newIndex]);

//       // handleNext - desktop branch
//       const visibleItems = getVisibleItems();
//       const activeEl = visibleItems.find(el => el.classList.contains('is-active'));
//       const visibleIndex = visibleItems.indexOf(activeEl);
//       let newIndex = visibleIndex + 1;
//       if (newIndex >= visibleItems.length) newIndex = 0;

//       // ✅ mediaId nikalo aur setActiveMedia call karo
//       const mediaId = visibleItems[newIndex].dataset.mediaId;
//       if (mediaId) {
//         gallery.setActiveMedia(mediaId, false);
//       } else {
//         visibleItems.forEach(el => el.classList.remove('is-active'));
//         visibleItems[newIndex].classList.add('is-active');
//       }
//       currentIndex = [...gallery.querySelectorAll('.product__media-item')].indexOf(visibleItems[newIndex]);
      
//     }
//   };

//   // ✅ Attach events (click + touch)
//   if (prev) {
//     prev.addEventListener('click', handlePrev);
//     prev.addEventListener('touchstart', handlePrev);
//   }

//   if (next) {
//     next.addEventListener('click', handleNext);
//     next.addEventListener('touchstart', handleNext);
//   }
// });

// // Variant change pe currentIndex sync karo
// document.addEventListener('variantChange', () => {
//   const activeItem = gallery.querySelector('.product__media-item.is-active');
//   if (!activeItem) return;
//   const allItems = [...gallery.querySelectorAll('.product__media-item')];
//   currentIndex = allItems.indexOf(activeItem);
// });


document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const prev = gallery.querySelector('.custom-prev');
  const next = gallery.querySelector('.custom-next');

  const getVisibleItems = () =>
    [...gallery.querySelectorAll('.product__media-item')]
      .filter(el => el.style.display !== 'none');

  let currentIndex = 0;
  window._galleryCurrentIndex = 0;

  const isMobile = () => window.innerWidth < 750;

  const getScrollContainer = () =>
    gallery.querySelector('ul') || gallery.querySelector('.media-gallery');

  const navigate = (direction) => {
    if (isMobile()) {
      const scroller = getScrollContainer();
      if (!scroller) return;
      scroller.scrollBy({
        left: direction === 'next' ? scroller.clientWidth : -scroller.clientWidth,
        behavior: 'smooth'
      });
      return;
    }

    const visibleItems = getVisibleItems();
    if (!visibleItems.length) return;

    const activeEl = visibleItems.find(el => el.classList.contains('is-active'));
    const visibleIndex = activeEl ? visibleItems.indexOf(activeEl) : 0;

    let newIndex;
    if (direction === 'next') {
      newIndex = visibleIndex + 1 >= visibleItems.length ? 0 : visibleIndex + 1;
    } else {
      newIndex = visibleIndex - 1 < 0 ? visibleItems.length - 1 : visibleIndex - 1;
    }

    const mediaId = visibleItems[newIndex].dataset.mediaId;
    if (mediaId && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, false);
    } else {
      visibleItems.forEach(el => el.classList.remove('is-active'));
      visibleItems[newIndex].classList.add('is-active');
    }

    currentIndex = [...gallery.querySelectorAll('.product__media-item')]
      .indexOf(visibleItems[newIndex]);
    window._galleryCurrentIndex = currentIndex;
  };

  const handlePrev = (e) => { e.preventDefault(); e.stopPropagation(); navigate('prev'); };
  const handleNext = (e) => { e.preventDefault(); e.stopPropagation(); navigate('next'); };

  if (prev) {
    prev.addEventListener('click', handlePrev);
    prev.addEventListener('touchstart', handlePrev, { passive: false });
  }
  if (next) {
    next.addEventListener('click', handleNext);
    next.addEventListener('touchstart', handleNext, { passive: false });
  }

  document.addEventListener('variantChange', () => {
    const activeItem = gallery.querySelector('.product__media-item.is-active');
    if (!activeItem) return;
    const allItems = [...gallery.querySelectorAll('.product__media-item')];
    currentIndex = allItems.indexOf(activeItem);
    window._galleryCurrentIndex = currentIndex;
  });
});